import { usePageTitle } from '@calendly/hooks';
import { I18n } from '@calendly/i18n';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { Layout } from 'components/layout';
const containerIsTabletUpCss = "c18nmo4v";
const containerWithinModalCss = "co3qonc";
const containerCss = "c1v6ltx7";
const Container = forwardRef((props, ref) => {
  const {
    withinModal,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isTabletUp = useDeviceType('isTabletUp');
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerIsTabletUpCss]: isTabletUp,
    [containerWithinModalCss]: withinModal
  }, props.className)} />;
});
const headerWrapperCss = "h1bp5s9v";
const HeaderWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(headerWrapperCss, props.className)} />;
});
const HeaderLayout = props => <Layout direction="column" gap="8" grow {...props} />;
const headerIsTabletUpCss = "h176n2t9";
const headerWithinModalCss = "h3c4msx";
const headerCss = "hoo3hn9";
const Header = forwardRef((props, ref) => {
  const {
    withinModal,
    ...restProps
  } = props;
  const isTabletUp = useDeviceType('isTabletUp');
  return <HeaderLayout ref={ref} {...restProps} className={classNames(headerCss, {
    [headerIsTabletUpCss]: isTabletUp,
    [headerWithinModalCss]: withinModal
  }, props.className)} />;
});
const contentIsTabletUpCss = "c1jnz7xy";
const contentWithinModalCss = "crpss49";
const contentSectionPaddingLeftCss = "c1dfx7li";
const contentSectionPaddingRightCss = "cuy5z79";
const contentCss = "c118tjos";
const Content = forwardRef((props, ref) => {
  const {
    withinModal,
    sectionPaddingLeft,
    sectionPaddingRight,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isTabletUp = useDeviceType('isTabletUp');
  return <Component ref={ref} {...restProps} className={classNames(contentCss, {
    [contentIsTabletUpCss]: isTabletUp,
    [contentWithinModalCss]: withinModal,
    [contentSectionPaddingLeftCss]: sectionPaddingLeft,
    [contentSectionPaddingRightCss]: sectionPaddingRight
  }, props.className)} />;
});
export const TabPage = forwardRef(({
  pageTitle,
  header,
  withinModal,
  sectionPaddingLeft,
  sectionPaddingRight,
  children
}, ref) => {
  const availabilityTitle = I18n.t('publisher.personal_settings.availability.title');
  usePageTitle(`${pageTitle} - ${availabilityTitle} - Calendly`);
  return <Container withinModal={withinModal}>
      <HeaderWrapper>
        <Header withinModal={withinModal}>{header}</Header>
      </HeaderWrapper>
      <Content ref={ref} withinModal={withinModal} sectionPaddingLeft={sectionPaddingLeft} sectionPaddingRight={sectionPaddingRight}>
        {children}
      </Content>
    </Container>;
});

require("./tab_page.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./tab_page.js");